module.exports = __webpack_public_path__ + "img/Exercises.330d1201.png";